

export default function PreviousYearPracticePage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">PreviousYearPractice</h1>
      <div className="card">
        <div className="card-content">
          <p className="text-gray-600">PreviousYearPractice content will be available here.</p>
        </div>
      </div>
    </div>
  );
}
